import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export default createSvgIcon(
  <>
    <circle cx="11.9999" cy="11.9999" r="10.1818" fill="url(#paint0_linear_2614_661)" />
    <defs>
      <linearGradient
        id="paint0_linear_2614_661"
        x1="3.99993"
        y1="4.72721"
        x2="22.1818"
        y2="19.2727"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9F5C35" />
        <stop offset="0.326615" stopColor="#CC9371" />
        <stop offset="0.511912" stopColor="#B37551" />
        <stop offset="1" stopColor="#301403" />
      </linearGradient>
    </defs>
  </>,
  'BronzeCoin'
);
